export const SUPPORT_STATUS_NEW = 'NEW'
export const SUPPORT_STATUS_WORK = 'WORK'
export const SUPPORT_STATUS_DONE = 'DONE'
export const SUPPORT_STATUS_REOPEN = 'REOPEN'
export const SUPPORT_STATUS_DELETE = 'DELETED'
